import { Avatar, Box, Typography, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const CardWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected?: boolean }>(({ theme, isSelected }) => ({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  width: '250px',
  minWidth: '250px',
  border: `1px solid ${isSelected ? theme.palette.primary.main : '#D7D8DB'}`,
  borderRadius: '14px',
  padding: '16px 16px 16px 24px',
  cursor: 'pointer',
  transition: 'border-color 0.2s, background 0.2s',
  background: isSelected ? alpha(theme.palette.primary.main, 0.06) : '#FFF',
  '&:hover': {
    borderColor: theme.palette.primary.main,
    background: alpha(theme.palette.primary.main, 0.04),
  },
}));

export const AvatarCircle = styled(Avatar)(() => ({
  width: '40px',
  height: '40px',
  fontSize: '14px',
  fontWeight: 700,
}));

export const CardName = styled(Typography)(() => ({
  marginTop: '4px',
  fontSize: '14px',
  fontWeight: 600,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const CardCount = styled(Typography)(() => ({
  fontSize: '12px',
  color: '#6A7282',
}));
